/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */

import React, { useContext, useEffect, useState } from 'react';
import Joyride, { STATUS } from 'react-joyride';

// context imports
import { ThemeContext } from '../../../contexts/ThemeContext';
import { AuthContext } from '../../../contexts/AuthContext';

// service imports
import AuthService from '../../../services/AuthService';
import DemoService from '../../../services/DemoService';

// local imports
import UserNotApproved from './UserNotApproved';
import ErrorBoundary from '../../general/ErrorBoundary';
import ProviderNavbar from './ProviderNavbar';
import AvailableTimings from './AvailableTimings';
import AvailableDays from './AvailableDays';

const AvailableTimingsAndDays = props => {

    // contexts
    const { theme } = useContext(ThemeContext);
    const { selectedTimeZone, userApprovalStatus } = useContext(AuthContext);

    // useStates
    const [user, setUser] = useState({ firstName: "", lastName: "", email: "", selectedRole: '', roles: [], profileImage: "", demoTakenFor: [] });
    const [tutorial, setTutorial] = useState({
        status: false,
        steps: [
            {
                content: <h2>Manage your available timings from here!</h2>,
                placement: 'center',
                target: '#timingsDiv',
            },
            {
                content: <div className="tooltipDiv">Manage the times you are available for a day from here. Your client will only be able to book a session with you within this time range.</div>,
                placement: 'bottom',
                target: '#availableTimings'
            },
            {
                content: <div className="tooltipDiv">Add multiple time range by pressing here.</div>,
                placement: 'bottom',
                target: '#addMoreAvailableTimings'
            },
            {
                content: <div className="tooltipDiv">Once you select your timings, press here to save it!</div>,
                placement: 'right',
                target: '#saveBtn'
            },
            {
                content: <div className="tooltipDiv">Toggle this switch to change your availability for a particular day.</div>,
                placement: 'right',
                target: '#availableDates0'
            },
            {
                content: <div className="tooltipDiv">Toggle this switch to change your availability for a particular slot in a day.</div>,
                placement: 'right',
                target: '#availableSlots0-1'
            },
        ]
    });
    const [availableDaysRefresh, setAvailableDaysRefresh] = useState({ status: false, updatedSlots: [] });
    let helpers = null;

    useEffect(() => {
        DemoService.getUserData().then(data => {
            if (data.isAuthenticated) {
                if (data.user.roles.includes("DemoProvider")) {
                    setUser(data.user);
                    if (!data.user.demoTakenFor.includes("AvailableTimingsAndDays")) {
                        setTutorial({ ...tutorial, status: true });
                    }
                } else {
                    // props.history.replace('PagePath');
                }
            } else {
                props.history.replace('/demo/signin');
            }
        })    }, []);

        const handleJoyrideCallback = (data) => {
            const { status, type } = data;
            const finishedStatuses = [STATUS.FINISHED, STATUS.SKIPPED];
        
            if (finishedStatuses.includes(status)) {
                if (!user.demoTakenFor.includes("AvailableTimingsAndDays")) {
                    DemoService.markVisited("AvailableTimingsAndDays");
                    setUser({ ...user, demoTakenFor: [...user.demoTakenFor, "AvailableTimingsAndDays"] });
                }
                setTutorial({ ...tutorial, status: false });
            }
        };

    const getHelpers = (paramHelpers) => {
        helpers = paramHelpers;
    };

    return (
        <div id="timingsDiv">
            <ErrorBoundary errorAt="At Provider AvailableTimingsAndDays ProviderNavbar">
                <ProviderNavbar history={props.history} showTutorial={() => setTutorial({ ...tutorial, status: true })} />
            </ErrorBoundary>
            {
                userApprovalStatus || true ?
                    <div>
                        <ErrorBoundary errorAt="At Provider AvailableTimingsAndDays Joyride">
                            <Joyride
                                callback={handleJoyrideCallback}
                                continuous={true}
                                getHelpers={getHelpers}
                                run={tutorial.status}
                                scrollToFirstStep={true}
                                showProgress={true}
                                showSkipButton={true}
                                steps={tutorial.steps}
                                locale={{ last: 'Finish' }}
                                styles={{
                                    options: {
                                        primaryColor: "rgb(56, 78, 115)",
                                        zIndex: 10000,
                                    },
                                }}
                            />
                        </ErrorBoundary>
                        <div className="p-3 container-fluid">
                            <div>
                                <h1 id="availableTiming-main-heading" style={theme.headingBold}>Available Timings</h1>
                                <hr style={{ borderWidth: "2px" }} />
                            </div>
                            <ErrorBoundary errorAt="At Provider AvailableTimingsAndDays AvailableTimings">
                                <AvailableTimings selectedTimeZone={selectedTimeZone} callAvailableDaysRefresh={(updatedSlots) => { setAvailableDaysRefresh({ status: !availableDaysRefresh.status, updatedSlots: updatedSlots }); }} />
                            </ErrorBoundary>
                            <ErrorBoundary errorAt="At Provider AvailableTimingsAndDays AvailableDays">
                                <AvailableDays selectedTimeZone={selectedTimeZone} doRefresh={availableDaysRefresh} />
                            </ErrorBoundary>
                        </div>
                    </div>
                    :
                    <UserNotApproved />
            }
        </div>
    )
}

export default AvailableTimingsAndDays;